<template>
  <div class="st- -sub">
    <div id="sidebar-overlay"></div>
    <div class="inner- -layer-4 -sub">
      <div class="_nav">
        <div class="_list">
          <ul>
            <li><router-link :to="{name: 'MypageMembersRoot'}">お知らせ</router-link></li>
            <li v-if="getUser().status === 3"><a>リクエスト</a>
              <ul>
                <li><router-link :to="{name: 'MypageMembersRequests'}">予約一覧</router-link></li>
                <li><router-link :to="{name: 'RequestsSitterWanted'}">サポーターさんを募集する</router-link></li>
              </ul>
            </li>
            <li v-if="getUser().status == 3"><a>サポーターさん</a>
              <ul>
                <li><router-link :to="{name: 'MypageMembersMessagesThreads'}">メッセージ一覧</router-link></li>
              </ul>
            </li>
            <li><a>プロフィール編集</a>
              <ul>
                <li><router-link :to="{name: 'MypageMembersProfile'}">ユーザー情報・内容更新</router-link></li>
                <li>子ども情報・内容更新
                  <ul class="list-in-list">
                      <li v-for="(kid, idx) in member.kids" :key="kid.namae">
                        <router-link :to="{name: 'MypageMembersKids', query: {idx: idx}}"><i class="fas fa-fw fa-user-circle"></i> {{ kid.MEMBER_KIDS_NAME }}</router-link>
                      </li>
                      <li><router-link :to="{name: 'MypageMembersKids', query: {idx: member.kids.length}}"><i class="fas fa-fw fa-plus-circle"></i> 新規登録</router-link></li>
                  </ul>
                </li>
                <li>
                  <router-link :to="{name: 'MypageMembersEmergencies'}">緊急連絡先・内容更新</router-link>
                </li>
              </ul>
            </li>
  <!-- 
            <li><a>支払い</a>
              <ul>
              <li><a href="">支払い一覧</a></li>
              </ul>
            </li>
  -->
            <li><a href="/static/page/logout.html">ログアウト</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      member: {kids:[]}
    }
  },
  async mounted() {
    const res = await this.authedFetch(`${process.env.BACK_ORIGIN}/members/me`);
    this.member = await res.json();
  }
};
</script>

<style lang="scss" scoped>
// @import "../../../assets/mypage/css/style_struct.css";

// 以下で無理やり上書き
.st-.-sub {
  min-width: 300px !important;
  width: auto !important;
}
.hierar-.-mypage- .st-.-sub ._nav ._list > ul > li > ul > li > ul > li:before {
	content: "" !important;
}
.hierar-.-mypage- .st-.-sub ._nav ._list > ul > li > ul > li > ul > li:last-of-type:before {
	content: "";
}
</style>


// WEBPACK FOOTER //
// src/components/mypage/members/MypageMembersAside.vue